export default "__VITE_ASSET__CUmzzJM3__"